import type { DashboardActiveFilters } from "components/DashboardFilterBar";

/** Form completion for a scope and date range, as the dashboards and Home pages show it. */
export interface FormCompletion {
    /** True until the first result arrives. */
    loading: boolean;
    /** submits ÷ sessions that got past the form's first step, 0-1. Null when nobody started the form, or the query failed. */
    rate: number | null;
}

export interface FormCompletionResult {
    fetching: boolean;
    error?: unknown;
    overall?: { engagedSessions: number; completionRate: number } | null;
}

export function toFormCompletion({ fetching, error, overall }: FormCompletionResult): FormCompletion {
    if (overall) {
        // The API answers 0 when nobody started the form; that is "no data", not 0%.
        return { loading: false, rate: overall.engagedSessions > 0 ? overall.completionRate : null };
    }
    return { loading: fetching && !error, rate: null };
}

export function formatCompletionRate(rate: number | null): string {
    return rate === null ? "—" : `${Math.round(rate * 100)}%`;
}

/**
 * Whether any lead filter is set. Those filter lead records, which only exist after a submit, so
 * they cannot narrow the form funnel — completion only follows the date range.
 */
export function hasLeadFilters(filters: DashboardActiveFilters | undefined): boolean {
    return !!filters && Object.values(filters).some((value) => value !== undefined);
}
